import PageWrapper from '../components/basic/PageWrapper';
import HeroSection from '../components/components/AirFreight/HeroSection';
import AboutSection from '../components/components/AirFreight/AboutSection';
import ServicesHighlights from '../components/components/AirFreight/ServicesHighlights';
import PerformanceSection from '../components/components/AirFreight/PerformanceSection';
import ChartsSection from '../components/components/AirFreight/ChartsSection';
import ComplianceSection from '../components/components/AirFreight/ComplianceSection';

const AirFreightPage = () => {
	return (
		<PageWrapper>
			<HeroSection />
			<AboutSection />
			<ServicesHighlights />
			<PerformanceSection />
			<ComplianceSection />
			<ChartsSection />
		</PageWrapper>
	);
};

export default AirFreightPage;
